import { getToolName, isToolUIPart } from "ai";

export const RENDER_TOOL_NAMES = new Set([
  "ask_clarification",
  "render_kpi",
  "render_table",
  "render_chart",
  "render_markdown",
]);

export const HIDDEN_TOOL_NAMES = new Set([
  "__assistant_status__",
  "run_python",
  "query_claims",
  "get_claim",
  "get_claim_history",
  "describe_data",
  "describe_column",
  "compare_groups",
]);

export function getMessageText(message) {
  return (message.parts || [])
    .filter((part) => part.type === "text")
    .map((part) => part.text)
    .join("");
}

export function uiMessageToApiMessage(message) {
  return {
    role: message.role,
    content: getMessageText(message),
  };
}

export function getToolParts(message) {
  return (message.parts || []).filter((part) => isToolUIPart(part));
}

export function getLatestAssistantStatus(message) {
  const statusPart = getToolParts(message)
    .filter((part) => getToolName(part) === "__assistant_status__")
    .at(-1);

  if (!statusPart?.input) {
    return null;
  }

  return statusPart.input;
}

export function getRenderableToolInput(part) {
  if (!part || part.input === undefined) {
    return null;
  }
  return part.input;
}

export function isThinkingMessage(message, isStreaming) {
  if (!isStreaming || message.role !== "assistant") {
    return false;
  }

  const text = getMessageText(message).trim();
  if (text) {
    return false;
  }

  const toolParts = getToolParts(message);
  return toolParts.length === 0 || toolParts.some((part) => HIDDEN_TOOL_NAMES.has(getToolName(part)));
}

export function getLatestClarification(messages) {
  if (!Array.isArray(messages) || messages.length === 0) {
    return null;
  }

  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index];
    if (message?.role !== "assistant") {
      continue;
    }

    const clarificationPart = getToolParts(message)
      .filter((part) => getToolName(part) === "ask_clarification")
      .at(-1);

    const clarificationInput = getRenderableToolInput(clarificationPart);
    if (
      clarificationInput?.question &&
      Array.isArray(clarificationInput?.suggestions) &&
      clarificationInput.suggestions.length > 0
    ) {
      return {
        ...clarificationInput,
        clarificationId: clarificationPart?.toolCallId || `${message.id}-clarification`,
      };
    }
  }

  return null;
}
